import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    buttonDefault: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    buttonSuperAdmin: {
      backgroundColor: palette.navSuperAdminActions,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
      },
    },
    buttonAdmin: {
      backgroundColor: palette.navAdminActions,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
      },
    },
    buttonOperator: {
      backgroundColor: palette.navOperatorActions,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
      },
    },
    divider: {
      width: '100%',
      margin: '0 0 18px',
      height: 0,
    },
    addButtonContainer: {
      display: 'flex',
      alignItems: 'center',

      '& div > svg': {
        fontSize: '15px !important',
        margin: '3px 11px 0px 0px',
      },
    },
    content: {
      marginBottom: 18,
    },
    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },
    chipContainer: {
      '& .MuiChip-root': {
        margin: 2,
        height: 18,
      },
    },
    additionalButtons: {
      fontSize: '12px !important',
    },
    notFoundText: {
      fontSize: 12,
    },
    addToken: {
      fontSize: 14,
      fontWeight: 500,
      color: palette.darkGray,
    },
    header: {
      alignItems: 'center',
      paddingBottom: 10,
      display: 'flex',
      marginBottom: 10,
    },
    backButton: {
      boxShadow: `0 1px 1px 0 ${palette.mediumShadow}, 0 2px 1px -1px ${palette.lightShadow}, 0 1px 3px 0 ${palette.darkShadow}`,
      color: palette.white,
      backgroundColor: palette.blue,
      fontSize: '12px !important',
      padding: '6px !important',
      height: '30px !important',
      '&:hover': {
        backgroundColor: palette.white,
        color: palette.blue,
        border: `0.7px solid ${palette.blue}`,
      },
      transition: 'opacity 0.3s',
    },
    upperButton: { margin: '0 !important', alignItems: 'center' },
    profile: {
      paddingBottom: 20,
      width: '100%',
      transition: 'all 0.5s ease-in-out',
    },
    edit: {
      width: '100%',
      transition: 'all 0.5s ease-out',
    },
    editIcon: { width: 15, height: 15 },
    backIcon: { width: 15, height: 15 },
  });
